import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/workflows/{workflowId}/owners']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateWorkflowOwners = async ({ owners, workflowId }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/workflows/${workflowId}/owners`, { owners });
  return response.data;
};

export default updateWorkflowOwners;
